export const FACEBOOK_FEED = 'facebook_feed'
export const FACEBOOK_PROFILE_FEED = 'facebook_profile_feed'
export const INSTAGRAM_STREAM = 'instagram_stream'
export const FACEBOOK_MARKETPLACE = 'facebook_marketplace'
export const FACEBOOK_VIDEO_FEEDS = 'facebook_video_feeds'
export const FACEBOOK_RIGHT_HAND_COLUMN = 'facebook_right_hand_column'
export const INSTAGRAM_EXPLORE = 'instagram_explore'
export const MESSENGER_MESSENGER_HOME = 'messenger_messenger_home'
export const FACEBOOK_STORY = 'facebook_story'
export const INSTAGRAM_STORY = 'instagram_story'
export const MESSENGER_STORY = 'messenger_story'
export const INSTAGRAM_REELS = 'instagram_reels'
export const FACEBOOK_INSTREAM_VIDEO = 'facebook_instream_video'
export const AUDIENCE_NETWORK_INSTREAM_VIDEO = 'audience_network_instream_video'
export const FACEBOOK_SEARCH = 'facebook_search'
export const MESSENGER_SPONSORED_MESSAGES = 'messenger_sponsored_messages'
export const FACEBOOK_INSTANT_ARTICLE = 'facebook_instant_article'
export const AUDIENCE_NETWORK_CLASSIC = 'audience_network_classic'
export const AUDIENCE_NETWORK_REWARDED_VIDEO = 'audience_network_rewarded_video'
export const FACEBOOK_BIZ_DISCO_FEED = 'facebook_biz_disco_feed'
export const FACEBOOK_FACEBOOK_REELS = 'facebook_facebook_reels'
export const FACEBOOK_FACEBOOK_REELS_OVERLAY = 'facebook_facebook_reels_overlay'
export const INSTAGRAM_IG_SEARCH = 'instagram_ig_search'
export const INSTAGRAM_PROFILE_FEED = 'instagram_profile_feed'
export const INSTAGRAM_EXPLORE_HOME = 'instagram_explore_home'
// todo: SHOP-1744 INSTAGRAM_REELS_OVERLAY item doesn't exist on BE, but it will be added. Correct the name when it's ready
export const INSTAGRAM_REELS_OVERLAY = 'instagram_reels_overlay'
export const INSTAGRAM_PROFILE_REELS = 'instagram_profile_reels'

export const lineItemRecommendedPlacementsList = [
  {
    value: FACEBOOK_FEED,
    label: 'Facebook Feed'
  },
  {
    value: INSTAGRAM_STREAM,
    label: 'Instagram Feed'
  },
  {
    value: INSTAGRAM_PROFILE_FEED,
    label: 'Instagram Profile Feed'
  },
  {
    value: FACEBOOK_VIDEO_FEEDS,
    label: 'Facebook Video Feeds'
  },
  {
    value: INSTAGRAM_EXPLORE,
    label: 'Instagram Explore'
  },
  {
    value: INSTAGRAM_EXPLORE_HOME,
    label: 'Instagram Explore Home'
  },
  {
    value: INSTAGRAM_STORY,
    label: 'Instagram Stories'
  },
  {
    value: MESSENGER_STORY,
    label: 'Messenger Stories'
  },
  {
    value: INSTAGRAM_REELS,
    label: 'Instagram Reels'
  },
  {
    value: INSTAGRAM_PROFILE_REELS,
    label: 'Instagram Profile Reels'
  },
  {
    value: FACEBOOK_FACEBOOK_REELS,
    label: 'Facebook Reels'
  },
  {
    value: FACEBOOK_INSTREAM_VIDEO,
    label: 'Facebook In-stream Videos'
  },
  {
    value: FACEBOOK_FACEBOOK_REELS_OVERLAY,
    label: 'Ads on Facebook Reels'
  },

  {
    value: FACEBOOK_RIGHT_HAND_COLUMN,
    label: 'Facebook Right Column'
  },
  {
    value: FACEBOOK_STORY,
    label: 'Facebook Stories'
  },
  {
    value: FACEBOOK_SEARCH,
    label: 'Facebook Search Results'
  },
  {
    value: INSTAGRAM_IG_SEARCH,
    label: 'Instagram Search Results'
  }
]
